export default __webpack_public_path__ + "static/media/gamers_outlet_v2.5d8c81c5.png";